export interface ResponsiveModalProps {
  type?: ModalType;
  id?: number;
  isOpen: boolean;
  onClose: () => void;
  selectedIpCategory?: number;
  title?: string;
  stats?: boolean;
  canCallEmergency?: any;
  photo?: string;
  phone?: string;
  adress?: string;
  website?: string;
  children?: React.ReactNode;
  long: any;
  lat: any;
  schedule?: string;
  date?: string;
  partener?: string;
}
export enum ModalType {
  Info,
  Defib,
  Event,
}
